import { Injectable } from '@angular/core';
import { CoreServiceRegistry } from '../../../../core/core-service-registry';
import { SharedServiceRegistry } from '../../../shared-service-registry';
import { SearchableEntityBackendService } from '../searchable-entity-backend.service';
import { SimpleEntityDataService } from './simple-entity-data.service';
import { Observable } from 'rxjs/Observable';
import { HttpHeaders } from '@angular/common/http';


@Injectable()
export class SimpleEntityBackendService extends SearchableEntityBackendService {

  protected dataService: SimpleEntityDataService;

  constructor(protected coreServiceRegistry: CoreServiceRegistry,
    protected sharedServiceRegistry: SharedServiceRegistry) {
    super(coreServiceRegistry, sharedServiceRegistry);
  }
  // Service call while creating an entity
  public saveEntity(requestItems: any) {
    const response$ = this.http$.put(`api/setup/`, JSON.stringify(requestItems))
      .map((response: any) => {
        return response;
      }).catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.statusCode && error.error.statusCode !== 200) {
             return Observable.throw(error.error.statusMessage);
           } else if (error.status === 400 && error.error.errors) {
             return Observable.throw(error.error.errors['0'].defaultMessage + ' - ' +
             error.error.errors['0'].rejectedValue);
           }
         }
      });
    return response$;
  }

  public delete(request: any) {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: request,
    };
    const response$ = this.http$.delete('api/setup/', options)
      .map((response: any) => {
        return response;
      })
      .catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          }
        }
      });
    return response$;
  }
  // LFWM-3191- made a new api /withPriv (replacement for setup api)
  //  to pass the privileges for checking the privileges at the backend level.
  // Service call while creating an entity
  public saveEntityWithPrivilege(requestItems: any) {
    const response$ = this.http$.put(`api/setup/withPriv/`, JSON.stringify(requestItems))
      .map((response: any) => {
        return response;
        // LFWM-3191-handling 403-forbidden error.
      }).catch((error: any) => {
        if (error.error.status === 403) {
          return Observable.throw(error.error.message);
        } else if (error.error.length !== 0) {
          if (error.error.statusCode && error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          } else if (error.status === 400 && error.error.errors) {
            return Observable.throw(error.error.errors['0'].defaultMessage + ' - ' +
              error.error.errors['0'].rejectedValue);
          }
        }
      });
    return response$;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/services/searchable-entity/simple-entity/simple-entity-backend.service.ts